module.exports = __webpack_public_path__ + "img/sp-icon-attached.ef885f1b.svg";